<script setup lang="ts">
import { useThemeStore, getTheme, themes, type Themes } from "@/stores/theme";
import ThemeSwitcher from "@/components/ThemeSwitcher";
import { useRoute } from "vue-router";
import { onMounted, computed, watchEffect } from "vue";
import mainComposable from "@/composables/main.js";
import { useStore } from 'vuex';

const store = useStore();
const route = useRoute();
const Component = computed(() => getTheme(themeStore.theme).component);
const isLoading = computed(() => store.state.auth.isProcessing);

const themeStore = useThemeStore();

watchEffect(() => {
  // console.log('watch is Loading: ', isLoading.value);
});
// const switchTheme = (theme: Themes["name"]) => {
//   useThemeStore().setTheme(theme);
// };

// watchEffect(() => {
//   console.log('Watch from Main Component, isProcessing:', isProcessing.value);
// });

const {
  isProcessing,
} = mainComposable(store);

onMounted(() => {
  const theme = route.query.theme as Themes["name"];
  if (
    route.query.theme !== undefined &&
    themes.map((theme) => theme.name).includes(theme)
  ) {
    // switchTheme(theme);
  }
});
</script>

<template>
<!--    <div class="overflow-hidden h-screen">-->
        <Component />
        <div v-if="isProcessing" class="loaderDiv flex items-center justify-center h-screen">
            <div class="loader">Test this</div>
        </div>
<!--    </div>-->

</template>
